export default __webpack_public_path__ + "static/media/Sur_mesure_Charme.2983358b.jpg";